import { useState } from 'react';
import { I18n } from 'common/i18n';
import {
  showToastOnPageReload,
  showForgeErrorToastNow,
  ToastType,
} from 'common/components/ToastNotification/Toastmaster';
import { fetchJsonWithDefaultHeaders, reload } from 'common/http';
import { useDerivedReport } from '../DerivedReportContext';

export function useEditDerivedReportMetadata() {
  const [saveInProgress, setSaveInProgress] = useState(false);
  const { currentStory } = useDerivedReport();

  const updateDerivedReport = async (name: string, description: string) => {
    setSaveInProgress(true);
    try {
      await fetchJsonWithDefaultHeaders(`/api/views/${currentStory.id}`, {
        method: 'PUT',
        body: JSON.stringify({
          name,
          description,
        }),
      });
      showToastOnPageReload({
        type: ToastType.SUCCESS,
        content: I18n.t('derived_story.update_success_toast', { reportName: name }),
        forceEscapeContent: true,
      });
      // Refresh the current page to show updated metadata
      reload();
    } catch (error) {
      console.error('Error saving changes to derived story: ', error);
      setSaveInProgress(false);
      showForgeErrorToastNow(I18n.t('derived_story.update_error_toast'));
    }
  };

  return { doSave: updateDerivedReport, saveInProgress };
}
